import { useState } from 'react'
import type { TaskResource } from '@/kinds/task/apply'
import { taskActions } from '@/lib/actions'
import { addDays, dayChoices, todayLocal } from '@/lib/time'
import { Button, Field, Sheet } from './ui'
import { ClashNote } from './DateBits'

/** Reschedule choices: the same days as quick add's "When?" (dayChoices), then a picker for anything else. */
export const DeferMenu = ({
  task,
  open,
  onClose,
  defaultDate,
}: {
  task: TaskResource
  open: boolean
  onClose: () => void
  defaultDate?: string
}) => {
  const today = todayLocal()
  const [date, setDate] = useState(defaultDate ?? addDays(today, 1))
  const [time, setTime] = useState(task.spec.scheduled_time ?? '')
  const go = async (d: string, t?: string) => {
    await taskActions.defer(task, d, t)
    onClose()
  }
  return (
    <Sheet open={open} onClose={onClose} title="When?">
      <div className="grid grid-cols-2 gap-2 mb-4">
        {dayChoices(today).map(([label, day]) => (
          <Button key={label} big onClick={() => void go(day)}>
            {label}
          </Button>
        ))}
      </div>
      <Field label="Pick a day">
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="w-full" />
      </Field>
      <Field label="Time (optional)" hint="Set a time and turn on reminders in the task to get a push.">
        <input type="time" value={time} onChange={(e) => setTime(e.target.value)} className="w-full" />
      </Field>
      <ClashNote day={date} time={time} minutes={task.spec.estimate_minutes} />
      <div className="flex justify-end">
        <Button variant="primary" big onClick={() => void go(date, time)} disabled={!date}>
          Schedule
        </Button>
      </div>
    </Sheet>
  )
}
